import styled from "styled-components"
// import regist from '@/img/user-new/regist.png'
import regist from '@/img/active20/anniu@2x.png'
import close from '@/img/user-new/close.png'
// import titileBack from '@/img/user-new/title-back.png'
import titileBack from '@/img/active20/title-back@2x.png'
import sbg1 from '@/img/active20/sbg1.png'
// import Bg from '@/img/members0604/regist.png'
import {color1,bg_color1,activity_state_color, card_bg_color, box_shadow} from '@/styles/theme'

// 分享H5样式 

export const ShareContainer = styled.div`
  min-height: 100vh;
  position: relative;
  width: 100%;
  box-sizing: border-box;
  .user_box{

    position:absolute;
    left:0;
    top:0;
    width: 100%;
    text-align:center;
    padding-top: 13vw;
  }
  .avatar{ 
    width: 70px;
    height: 70px;
    // background: #eee;
    border:3px solid #ffffff;
    border-radius: 50%;
  }
  .nickname{
    margin:10px auto 9px;
    display: inline-block;
    height: 28px;
    font-size: 15px;
    font-family: Alibaba PuHuiTi;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 28px;
    padding: 0 22px;
    background: #FE7259;
    border-radius: 24px;
    
  }
  .tip{
    font-size:17px;
    font-family: Alibaba PuHuiTi;
    font-weight: 400;
    color: #FFFFFF;
  }
  .footer,.header{
    width:100%;
  }
  footer {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FF909E;
    text-align: center;
    line-height: 1.5;
    margin: 12px 0 12px
  }
  >img{
    max-width:100%;
  }
`

export const RegistContainer = styled.div`
  margin: -61vw auto 0;
  position: relative;
  z-index:2;
  width: calc(100% - 20px);
  box-sizing: border-box;
  border-radius: 10px;
  background-image: url(${sbg1});
  background-repeat: no-repeat;
  background-size: 100%;
  width: 100%;
  height: 139vw;
  padding-top: 70.6vw;
  .container{
  
    margin:auto;
    // display: ${props=>props.Empty? 'flex':'block '};
    // justify-content: center;
    // align-items: ${props=>props.Empty?  'baseline':'center'};
    box-sizing: border-box;
    .message{
      color: #E0B6A4;
      line-height: 18px;
      text-align:center;
      font-size:12px;
    }
  }
  .tips {
    text-align: center;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #868686;
    line-height: 43px;
} 
`

export const FormCotainer = styled.div`
    padding:0 22px;
    margin-top: 20px;
  .form-item{
    margin: 3.5vw auto;
    padding: 3.7vw 8px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    width: 69.3vw;
    overflow: hidden;
    height: 13.33vw;
    max-height: 50px;
    background: #ffffff;
    border-radius: 6.66vw;
    .am-list-item{
      width: 100%;
      background: #ffffff;
    }
    .am-list-item:not(:last-child) .am-list-line::after{
      background-color: transparent;
    }
    .am-list-item:not(:last-child) .am-list-line {
      border: none;
    }
    .am-list-item .am-input-clear{
      background-image: url(${close});
      background-color: transparent;
      background-size : 21px;
      background-position: 0 0;
      border-radius: 0;
    }
    .button{
      margin-left: 10px;
      margin-right: 10px;
      width: 94px;
      text-align: right;
    //   background: #F6F6F8;
      border: none;
      outline: none;
      color: #9696A6;
    }
    .active{
      color: #9C775A;
    }
 
  }
  .am-list-item.am-input-item{
    padding-left: 10px;
  }
  .am-list-item{
    .am-input-label{
      width: 32px;
      font-size: 14px;
      color: #333;
    }
    .am-input-control input {
      font-size: 16px;
      color: #333;
    }
    .am-input-label{
      position: relative;
      overflow: visible;
    }
    .am-input-label:before{
      position: absolute;
      content: '';
      right: -1px;
      top: -2px;
      width: 1px;
      height: 24px;
      background: #979797;
      transform: scale(0.8);
    }
  }
  .text{
      flex: 1;
      background: #F6F6F8;
      border: none;
      outline: none;
      .am-input-control input{
        font-size: 14px;
      }
    }
  .regist {
    text-align: center;
    > img{
        max-height: 60px;
        width: 69.3vw;
        margin:auto;
    }
  }
 
`
  
export const RegistModalContent = styled.div`

  .regist-modal-content-text{
    text-align: center∂;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #333;
  }
  .regist-modal-content-group{
    margin: 24px auto 0;
    display: flex;
    justify-content: space-around;
  }
  .regist-modal-content-button{
    width: 151px;
    font-size: 14px;
    text-align: center;
    line-height: 54px;
    color: #ffff;
    font-weight: 500;
    border-radius: 20px;
    border:none;
    background: url(${regist}) no-repeat center;
    background-size: 100% 100%;
  }
  .regist-modal-button{
    display: flex;
    align-items: center;
    .modal-button{
      background: url(${regist}) no-repeat center;
      background-size: 100% 100%;
      margin: 0 5px;
      width: 151px;
      height: 50px;
      font-size: 14px;
      color:#ffffff;
      line-height:50px;
    }
  }
`

export const ActivtyContainer = styled.div`
  position: relative;
  width: 100%;
  padding-top: 44px;
  /* margin-bottom: 40px; */
  min-height: calc(100vh - 84px);
  background: ${bg_color1};
  box-sizing: border-box;
`
export const ActiveCard = styled.div`
  width: calc(100% - 20px);
  margin: 6px auto 24px;
  box-sizing: border-box;
  background: ${card_bg_color};
  box-shadow: ${box_shadow};
  border-radius: 6px;
  .img-container{
    position: relative;
    width: 100%;
    height: 180px;
    border-radius: 6px 6px 0 0;
    img{
      border-radius: 6px 6px 0 0;
      width: 100%;
      height: 100%;
      filter: ${props=>props.state=== 2? 'grayscale(100%) saturate(0.1)': 'none'};
    }
    .activity-state{
      position: absolute;
      top: 0;
      left: 0;
      &:before{
        position: absolute;
        content: '活动已结束';
        font-size: 12px;
        font-weight: 600;
        color: ${activity_state_color}; 
        top: 0;
        left: 0;
        z-index: 999;
        width:88px;
        height: 32px;
        background: ${card_bg_color};
        border-radius: 5px 0px 16px 0px;
        line-height: 32px;
        text-align: center;
      }
    }
  }
  .content{
    padding: 16px;
    .title{
      margin-bottom: 10px;
      font-size: 14px;
      font-weight: 500;
      color: ${color1};
      line-height: 20px;
    }
    .date{
      font-size: 12px;
      font-weight: 400;
      color: #646472;
      line-height: 17px;
    }
  }
`


export const CTitle = styled.div`
  // position: relative;
  // z-index:2000;
  .title{
    position: absolute;
    top:  0;
    top: 0;
    z-index: 2051;
    left: 45px;
    right: 45px;
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    color: #511e21;
    font-weight: 600;
    color: #fff;
    background-image: url(${titileBack});
    // background-image: linear-gradient(180deg, #FFE600 0%, #FFC800 100%);
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .back{
    width: calc(100% - 62px);
    height: 10px;
    position: absolute;
    top: 0;
    left: 31px;
    overflow: hidden;
    z-index: 2000;
    &:before{
      content: ' ';
      position: absolute;
      top: 0;
      left: 0;
      z-index: 3000;
      width: 100%;
      height: 29px;
      border-radius: 15px;
      background-color: #c93432;
    }
  }
  .prize-header{
    position: absolute;
    height: 81px;
    top: -74px;
    left: 50%;
    transform: translateX(-50%);
  }
`


export const Center =styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

`


// WEBPACK FOOTER //
// ./src/views/integral_0803_20/share-pull-regist/style.js